import React from 'react'
import classes from "./Seventh.module.scss"
import { Swiper, SwiperSlide } from 'swiper/react';
// import { Navigation, Pagination } from 'swiper/modules';
import { Pagination, Navigation } from "swiper/core";
import 'swiper/css';
import img1 from "../../../assets/img/MainPage/7/1.svg"


const Seventh = () => {

    const pagination = {
        clickable: true,
        renderBullet: function (index, className) {
            return '<span class="' + className + '">' + '</span>';
        },
    };

    return (
        <div className={[classes.fifth, ""].join(" ")}>
            <div className={[classes.fifthBody, ""].join(" ")}>


                <div className={[classes.fifthSlider, ""].join(" ")}>
                    <Swiper
                        pagination={pagination}
                        modules={[Pagination, Navigation]}
                        navigation={true}
                        // pagination={{
                        //     clickable: true,
                        // }}

                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                            },

                        }}
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => {
                            // console.log(swiper)
                        }}
                    >
                        <SwiperSlide>
                            <div className={[classes.fifthSliderSlide, ""].join(" ")}>
                                <div className={[classes.fifthSliderSlideImg, ""].join(" ")}>
                                    <img src={img1} alt="" />
                                </div>
                                <div className={[classes.fifthSliderSlideText, ""].join(" ")}>
                                    “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque augue eros, pellentesque nec tempor eu, sollicitudin at dolor. Cras commodo venenatis diam, nec venenatis massa auctor at. Aliquam semper ante libero, non pharetra enim lacinia malesuada.”
                                </div>
                                <div className={[classes.fifthSliderSlideName, ""].join(" ")}>
                                    Quisque Mattis
                                </div>

                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={[classes.fifthSliderSlide, ""].join(" ")}>
                                <div className={[classes.fifthSliderSlideImg, ""].join(" ")}>
                                    <img src={img1} alt="" />
                                </div>
                                <div className={[classes.fifthSliderSlideText, ""].join(" ")}>
                                    “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque augue eros, pellentesque nec tempor eu, sollicitudin at dolor. Cras commodo venenatis diam, nec venenatis massa auctor at. Aliquam semper ante libero, non pharetra enim lacinia malesuada.”
                                </div>
                                <div className={[classes.fifthSliderSlideName, ""].join(" ")}>
                                    Quisque Mattis
                                </div>

                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={[classes.fifthSliderSlide, ""].join(" ")}>
                                <div className={[classes.fifthSliderSlideImg, ""].join(" ")}>
                                    <img src={img1} alt="" />
                                </div>
                                <div className={[classes.fifthSliderSlideText, ""].join(" ")}>
                                    “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque augue eros, pellentesque nec tempor eu, sollicitudin at dolor. Cras commodo venenatis diam, nec venenatis massa auctor at. Aliquam semper ante libero, non pharetra enim lacinia malesuada.”
                                </div>
                                <div className={[classes.fifthSliderSlideName, ""].join(" ")}>
                                    Quisque Mattis
                                </div>

                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={[classes.fifthSliderSlide, ""].join(" ")}>
                                <div className={[classes.fifthSliderSlideImg, ""].join(" ")}>
                                    <img src={img1} alt="" />
                                </div>
                                <div className={[classes.fifthSliderSlideText, ""].join(" ")}>
                                    “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque augue eros, pellentesque nec tempor eu, sollicitudin at dolor. Cras commodo venenatis diam, nec venenatis massa auctor at. Aliquam semper ante libero, non pharetra enim lacinia malesuada.”
                                </div>
                                <div className={[classes.fifthSliderSlideName, ""].join(" ")}>
                                    Quisque Mattis
                                </div>

                            </div>
                        </SwiperSlide>
                        <SwiperSlide>
                            <div className={[classes.fifthSliderSlide, ""].join(" ")}>
                                <div className={[classes.fifthSliderSlideImg, ""].join(" ")}>
                                    <img src={img1} alt="" />
                                </div>
                                <div className={[classes.fifthSliderSlideText, ""].join(" ")}>
                                    “Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque augue eros, pellentesque nec tempor eu, sollicitudin at dolor. Cras commodo venenatis diam, nec venenatis massa auctor at. Aliquam semper ante libero, non pharetra enim lacinia malesuada.”
                                </div>
                                <div className={[classes.fifthSliderSlideName, ""].join(" ")}>
                                    Quisque Mattis
                                </div>

                            </div>
                        </SwiperSlide>
                    </Swiper>
                </div>



            </div>
        </div>
    )
}

export default Seventh